var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsAudioPlayIcon = function SvgDsAudioPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#DSAudioPlayIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 7,
    y: 7,
    fill: "#fff",
    rx: 18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 7,
    y: 7,
    stroke: "#E2E2E2",
    rx: 18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    d: "M30.106 23.464c1.192.674 1.192 2.398 0 3.072l-7.493 4.235c-1.169.66-2.613-.188-2.613-1.536v-8.47c0-1.348 1.444-2.197 2.613-1.536z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "DSAudioPlayIcon_svg__a",
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2022_10736"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2022_10736",
    result: "shape"
  })))));
};
export default SvgDsAudioPlayIcon;